<template>
  <div class="alert alert-warning" v-if="showConsultOpenedByOtherWarning">
    Warning: this consult was created on {{ openedDate }} by {{ consultOpenedByEmail }} and may be out of date. If you
    wish to start a new consult with up-to-date data then please contact {{ consultOpenedByEmail }} or the Data Team to
    have this old consult submitted or removed before proceeding.
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getCurrentUser } from '@/_helpers'
export default {
  name: 'ConsultOpenedByOtherWarning',
  computed: {
    ...mapGetters('currentConsult', ['getFieldValue', 'consultOpenedDate']),
    consultOpenedByEmail: function () {
      return this.getFieldValue('consult_opened_by_email', 'Misc')
    },
    openedDate: function () {
      let openedDate = this.$moment(this.consultOpenedDate)
      return openedDate.format('dddd') + ' the ' + openedDate.format('Do MMMM YYYY')
    },
    showConsultOpenedByOtherWarning: function () {
      return (
        this.getFieldValue('consult_state', 'Misc') != 'finished' &&
        this.getFieldValue('consult_opened_by', 'Misc') != getCurrentUser().id &&
        this.getFieldValue('consult_opened_by_email', 'Misc') != undefined
      )
    },
  },
}
</script>
